import { render, staticRenderFns } from "./SAvatarUpload.vue?vue&type=template&id=6745e1ed&scoped=true"
import script from "./SAvatarUpload.vue?vue&type=script&lang=js"
export * from "./SAvatarUpload.vue?vue&type=script&lang=js"
import style0 from "./SAvatarUpload.vue?vue&type=style&index=0&id=6745e1ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6745e1ed",
  null
  
)

export default component.exports